/**
 * Main navigation. `ready` = module available in the current iteration; others render a "coming soon" page.
 * Technical keys are stable (used for routes and data-testids); labels come from i18n (nav.*).
 */
import {
  LayoutDashboard, Sparkles, Share2, Users, Handshake, CalendarClock, FileText, BarChart3, Workflow, Brain, Plug, Settings, Activity, Inbox, Bot,
} from "lucide-react";

export const NAV_GROUPS = [
  {
    key: "pilot",
    items: [
      { key: "dashboard", path: "/app", icon: LayoutDashboard, ready: true, end: true },
      { key: "assistant", path: "/app/assistant", icon: Sparkles, ready: true },
      { key: "agentsUi", path: "/app/agents", icon: Bot, ready: true },
      { key: "approvals", path: "/app/approvals", icon: Inbox, ready: true },
    ],
  },
  {
    key: "execute",
    items: [
      { key: "crm", path: "/app/crm", icon: Users, ready: true },
      { key: "social", path: "/app/social", icon: Share2, ready: true },
      { key: "sales", path: "/app/sales", icon: Handshake, ready: false },
      { key: "meetings", path: "/app/meetings", icon: CalendarClock, ready: false },
      { key: "proposals", path: "/app/proposals", icon: FileText, ready: false },
    ],
  },
  {
    key: "data",
    items: [
      { key: "analytics", path: "/app/analytics", icon: BarChart3, ready: false },
      { key: "automations", path: "/app/automations", icon: Workflow, ready: false },
      { key: "aiOps", path: "/app/ai", icon: Activity, ready: true },
      { key: "brandBrain", path: "/app/brand-brain", icon: Brain, ready: true },
    ],
  },
  {
    key: "system",
    items: [
      { key: "integrations", path: "/app/integrations", icon: Plug, ready: false },
      { key: "settings", path: "/app/settings", icon: Settings, ready: true },
    ],
  },
];

export const NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);
export const COMING_SOON_ITEMS = NAV_ITEMS.filter((i) => !i.ready);
